import HeroBackgroundPage from '@/components/templates/HeroBackgroundPage';
import { CREATOR_APPLICATION_BACKGROUND, CREATOR_APPLICATION_BACKGROUND_OPACITY } from '@/constants/creatorApplication';
import CreatorApplicationForm from '@/modules/contentCreator/CreatorApplicationForm';
import { createFileRoute, redirect } from '@tanstack/react-router';

const CreatorApplicationPage = () => {

  return (
    <HeroBackgroundPage
      heroChildren={<CreatorApplicationForm />}
      backgroundOverlay={CREATOR_APPLICATION_BACKGROUND}
      backgroundOverlayOpacity={CREATOR_APPLICATION_BACKGROUND_OPACITY}
      isBackgroundFixed
    />
  );
};

export const Route = createFileRoute('/creator/apply/application/')({
  staticData: { title: 'Creator Application' },
  component: CreatorApplicationPage,
  beforeLoad: ({ context: { auth } }) => {
    if (!auth?.isAuthenticated) {
      throw redirect({ to: '/creator/apply/form' });
    }
  },
});
